export class pagination {
  public total_count : number = 0;
  public page_size: number = 0;
  public current_page: number = 0;
  public total_pages: number = 0;
  public previous_page_link: string = "";
  public next_page_link: string = "";
  public memory_id: string = "";
}
